/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Chat_S2Inputs */

const en_mk_tut_chat_s2 = /** @type {(inputs: Mk_Tut_Chat_S2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To involve an agent type \`@\` and pick its name from the list that appears. Picking from the list matters — typing the name alone does not summon anyone.`)
};

const id_mk_tut_chat_s2 = /** @type {(inputs: Mk_Tut_Chat_S2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untuk melibatkan agen, ketik \`@\` lalu pilih namanya dari daftar yang muncul. Memilih dari daftar itu penting — mengetik nama saja tidak memanggil agen.`)
};

/**
* | output |
* | --- |
* | "To involve an agent type `@` and pick its name from the list that appears. Picking from the list matters — typing the name alone does not summon anyone." |
*
* @param {Mk_Tut_Chat_S2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_chat_s2 = /** @type {((inputs?: Mk_Tut_Chat_S2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Chat_S2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_chat_s2(inputs)
	return en_mk_tut_chat_s2(inputs)
});